<script setup lang="ts">
  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String },
    headerType: { type: String },
    content: { type: String },
  });
</script>
<template>
  <SfSection :title="header" :headerType>
    <QuillContent v-if="content" :content />
  </SfSection>
</template>
